import Dexie from 'dexie';
import type { Table } from 'dexie';
import type { CommunityOperation, LocalPostAttachment, LocalPostDraft, LocalCommunityHistory } from '../api/requests';
export async function removeCommunityStores(origin: string, accountId: string) {
  for (const name of await Dexie.getDatabaseNames()) {
    if (!name.startsWith('hylo-web-community-')) continue;
    let scope: unknown; try { scope = JSON.parse(decodeURIComponent(name.slice('hylo-web-community-'.length))); } catch { continue; }
    if (Array.isArray(scope) && scope[0] === origin && scope[2] === accountId) await Dexie.delete(name);
  }
}
export class CommunityDatabase extends Dexie {
  drafts!: Table<LocalPostDraft, string>;
  attachments!: Table<LocalPostAttachment, string>;
  operations!: Table<CommunityOperation, string>;
  history!: Table<LocalCommunityHistory, string>;
  commentDrafts!: Table<{ id: string; body: string; replyTo: string | null; intent: { id: string; body: string; replyTo: string | null; revisionId: string } | null }, string>;
  constructor(scope: string) {
    super(`hylo-web-community-${encodeURIComponent(scope)}`);
    this.version(1).stores({ drafts: 'id,postId,updatedAt,state', attachments: 'id,draftId,mediaId', operations: 'id,targetKey,state,createdAt', history: 'id', commentDrafts: 'id' });
  }
  async discard(id: string) {
    await this.transaction('rw', this.drafts, this.attachments, this.operations, async () => {
      await this.drafts.delete(id); await this.attachments.where('draftId').equals(id).delete();
      await this.operations.filter(op => op.draftId === id).delete();
    });
  }
}
